$(function () {
	window.addEventListener('resize', function () {
		preHeader();
		welcomeSection();
	}, false);
	window.addEventListener('scroll', function () {
		//preHeader();
	}, false);


	/* Pre header */
	function preHeader() {
		$('.pre-header').css({'height': Math.ceil($('header').outerHeight(true)) + 'px'});
	}

	preHeader();
	/* eo Pre header */


	/* Welcome */
	var welcome = $('#welcome'),
		welcome_limit = 568;

	function welcomeSection() {
		var welcome_height = $(window).height();

		if (welcome_height < welcome_limit) {
			welcome_height = welcome_limit;
		}

		if ($(window).width() < 768) {
			welcome_height = $(window).height();
		}

		welcome.css({'height': welcome_height});
	}

	welcomeSection();
	/* eo Welcome */


	/* Tabs */
	$('.tabs-container a').on('click', function (e) {
		e.preventDefault();

		$(this).addClass('active').siblings().removeClass('active');

		var href = $(this).attr('href');

		if (!$(href).length) return false;

		$(href).addClass('active').siblings().removeClass('active');
	});
	/* eo Tabs */


	$('.product-types .title a').on('click', function (e) {
		e.preventDefault();

		$(this).closest('.item').toggleClass('active').find('.content').stop().slideToggle();
	});


	/* Sliders */
	function auto_slider(wrapper, settings) {
		wrapper = $(wrapper);

		if (!wrapper.length) {
			return false;
		}

		if (wrapper.is('.slick-initialized')) {
			wrapper.slick('unslick');
		}

		wrapper.on('init', function (event, slick) {
			$(document).ready(function () {
				wrapper.addClass('fade-active');
			});
		});

		wrapper.slick(settings);

		return false;
	}

	var reviews_settings = {
		autoplay: false,
		autoplaySpeed: 4000,
		infinite: false,
		speed: 600,
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: true,
		customPaging: function (slider, i) {
			return $('<a data-role="none" role="button" tabindex="0"></a>');
		},
		nextArrow: '<a data-role="none" class="slick-next" aria-label="" tabindex="0" role="button"></a>',
		prevArrow: '<a data-role="none" class="slick-prev" aria-label="" tabindex="1" role="button"></a>',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	};
	auto_slider('.reviews-container', reviews_settings);

	var images_settings = {
		autoplay: false,
		autoplaySpeed: 4000,
		infinite: false,
		speed: 600,
		slidesToShow: 6,
		slidesToScroll: 1,
		dots: true,
		customPaging: function (slider, i) {
			return $('<a data-role="none" role="button" tabindex="0"></a>');
		},
		nextArrow: '<a data-role="none" class="slick-next" aria-label="" tabindex="0" role="button"></a>',
		prevArrow: '<a data-role="none" class="slick-prev" aria-label="" tabindex="1" role="button"></a>',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			}
		]
	};
	auto_slider('.images-slider', images_settings);
	/* eo Sliders */


	/* Amount */
	$('.minus, .plus').on('click', function () {
		var
			input = $(this).parent().find('input'),
			cur_value = input.val();

		if ($(this).is('.minus')) {
			if (cur_value > 1) {
				cur_value--;
			}
		} else {
			if (cur_value < 99) {
				cur_value++;
			}
		}

		input.val(cur_value).trigger('change');
	});
	/* eo Amount */


	$('table').each(function () {
		if (!$(this).is('.noresponsive')) {
			$(this).wrap('<div class="responsive-table"></div>');
		}
	});


	$('.gonext').on('click', function () {
		$('html, body').animate({
			scrollTop: $(this).position().top
		}, 600, 'easeInOutQuint');
	});
	$('.goto').on('click', function (e) {
		e.preventDefault();

		var href = $(this).attr('href');

		href = href.split('#');

		gotoElement('#' + href[1]);
	});


	$('.select-container select').on('change', function () {
		if ($(this).val() !== '') {
			$(this).next('.placeholder').hide();
		} else {
			$(this).next('.placeholder').show();
		}
	});


	/* Mobile menu */
	$('.menu-switch').on('click', function () {
		$('.mobile-menu').toggleClass('active');
		$('body').toggleClass('locked');
	});
	$('.mobile-back').on('click', function () {
		$('.mobile-menu').removeClass('active');
		$('body').removeClass('locked');
	});


	/* Modal */
	$('body').on('click', '[data-modal]', function () {
		var
			modal_window = $(this).data('modal'),
			modal_value = $(this).data('value'),
			modal_image = $(this).data('image'),
			modal_district = $(this).data('district');

		closeModals();

		if (modal_value) {
			$('#' + modal_window + ' .modal-what').html(modal_value).addClass('active');
			$('#' + modal_window + ' input[name="subject"]').val(modal_value);
		}

		if (modal_image) {
			$('#' + modal_window + ' .modal-image').html('<img src="' + modal_image + '" alt="" />');
		} else {
			$('#' + modal_window).addClass('bg' + rand(1, 2));;
			$('#' + modal_window + ' .modal-image').html('');
		}

		if (modal_district) {
			$('#' + modal_window + ' select[name="district"]').val(modal_district).trigger('change');
		}

		showModal(modal_window);
	});
	$('.modal-close').on('click', function () {
		var modal_window = $(this).closest('modal-form').attr('id');
		closeModals();
		$('#' + modal_window).trigger('modal_window:off');
	});
	$('.modal-form').on('modal_window:on', function () {
		$(document).on('mouseup', function (e) {
			var container = $('.modal-form, #ui-datepicker-div');
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				closeModals();
				container.trigger('modal_window:off');
			}
		});
	});
	$(document).keyup(function(e) {
		if (e.key === "Escape") {
			closeModals();
		}
	});


	/* Form */
	$('.form-container').on('submit', function () {
		var
			url = window.location.href,
			id = $(this).attr('id'),
			form = $('#' + id);


		form.find('.btn').css({'visibility': 'hidden'});

		$.ajax({
			url: '/assets/template/form/send.php',
			type: 'post',
			data: form.serialize() + '&url=' + url,
			dataType: 'json',
			success: function (json) {
				if (json.success) {
					form[0].reset();
					closeModals();
					Swal.fire(
						'Отправлено!',
						'В ближайшее время мы свяжемся с вами!',
						'success'
					);
					//swal({ title: 'Отправлено', text: 'В ближайшее время мы свяжемся с вами!', type: 'success' });
				} else {
					//swal({ title: 'Ошибка', text: 'Попробуйте еще раз!', type: 'error' });
					Swal.fire(
						'Ошибка!',
						'Попробуйте еще раз!',
						'error'
					);
				}

				form.find('.btn').css({'visibility': 'visible'});
			}
		});

		return false;
	});

	$('input[type="tel"]').mask('8 (999) 999-99-99');

}); // eo ready

function showModal(id) {
	if ($('#' + id).length) {
		$('#modal-back').addClass('active');

		$('#' + id).addClass('active').trigger('modal_window:on');

		if ($(window).width() <= 767) {
			$('body').addClass('locked');
		}
	}

	return false;
}

function closeModals() {
	$('#modal-back, .modal-form').removeClass('active');

	$('.modal-form').removeClass('bg1 bg2');

	$('.modal-what').html('').removeClass('active');

	$('.modal-form input[name="subject"], .modal-form select[name="district"]').val('').trigger('change');

	$('body').removeClass('locked');

	return false;
}

function numberFormat(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function gotoElement(el) {
	if ($(el).length) {
		var offset_top = $(el).offset().top;

		$('html, body').animate({
			scrollTop: offset_top
		}, 600, 'easeInOutQuint');
	}

	return false;
}

function setCookie(c_name, value, exdays) {
	var exdate = new Date();
	exdate.setDate(exdate.getDate() + exdays);
	var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
	document.cookie = c_name + "=" + c_value + "; path=/";
}

function getCookie(c_name) {
	var c_value = document.cookie;
	var c_start = c_value.indexOf(" " + c_name + "=");
	if (c_start == -1) {
		c_start = c_value.indexOf(c_name + "=");
	}
	if (c_start == -1) {
		c_value = null;
	} else {
		c_start = c_value.indexOf("=", c_start) + 1;
		var c_end = c_value.indexOf(";", c_start);
		if (c_end == -1) {
			c_end = c_value.length;
		}
		c_value = unescape(c_value.substring(c_start, c_end));
	}
	return c_value;
}


function print_r(arr, level) {
	var print_red_text = "";
	if (!level) level = 0;
	var level_padding = "";
	for (var j = 0; j < level + 1; j++) level_padding += "    ";
	if (typeof (arr) == 'object') {
		for (var item in arr) {
			var value = arr[item];
			if (typeof (value) == 'object') {
				print_red_text += level_padding + "'" + item + "' :\n";
				print_red_text += print_r(value, level + 1);
			} else
				print_red_text += level_padding + "'" + item + "' => \"" + value + "\"\n";
		}
	} else print_red_text = "===>" + arr + "<===(" + typeof (arr) + ")";
	return print_red_text;
}

function rand(min, max) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}